export const environment = {
  production: true,
  applicationStage: $ENV.PB_APPLICATION_STAGE,
};
